import React, { useContext } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ProfileContext } from '../contexts/ProfileContext';

import { Popups } from '../components';
import { PhoneOutgoingIcon } from '@phosphor-icons/react';
import { RxAvatar, RxEnvelopeOpen } from 'react-icons/rx';
import { FaWhatsapp } from 'react-icons/fa';

export default function PgVideoTips() {
  const { id } = useParams();

  const { i18n } = useTranslation();

  const [profile] = useContext(ProfileContext);

  const {
    profileTypeData: { videos = [] }
  } = profile;

  const videoTipsDetails = videos?.find(
    (video) => Number(video?.videoPage?.index) === Number(id)
  )?.videoTips;

  if (!videoTipsDetails) {
    return <Navigate to={`/video/${id}`} replace />;
  }

  return (
    <Popups.FullPagePopup closeLink={`/video/${id}`}>
      <div className="container mx-auto max-w-xl">
        <h2
          className="text-xl font-bold text-black mb-8"
          dangerouslySetInnerHTML={{
            __html: videoTipsDetails?.title?.[i18n.language]
          }}
        />
        <h3
          className="text-xl font-bold text-black"
          dangerouslySetInnerHTML={{
            __html: videoTipsDetails?.explainerSection?.title?.[i18n.language]
          }}
        />
        <p
          className="text-lg text-grey-200"
          dangerouslySetInnerHTML={{
            __html: videoTipsDetails?.explainerSection?.description?.[i18n.language]
          }}
        />

        {/* Slider */}
        <div className="relative">
          <div className="flex flex-row overflow-x-auto gap-4 my-6 pr-12">
            {videoTipsDetails?.tips?.map((tip) => {
              return (
                <div
                  key={tip?.id}
                  className={`block border-[1px] w-[70%] min-w-[70%] max-w-[70%] border-black rounded-xl p-6`}>
                  <span className="block mb-6">
                    <img
                      className="w-10 h-10 object-contain"
                      src={process.env.REACT_APP_AWS_URL + tip?.icon}
                      alt={tip?.title?.[i18n.language]}
                    />
                  </span>
                  <p
                    className="text-lg font-bold text-black mb-2"
                    dangerouslySetInnerHTML={{
                      __html: tip?.title?.[i18n.language]
                    }}
                  />
                  <p
                    className="text-base font-normal text-grey-200"
                    dangerouslySetInnerHTML={{
                      __html: tip?.description?.[i18n.language]
                    }}
                  />
                </div>
              );
            })}
          </div>
        </div>

        <div
          className="mt-12 text-xl font-bold text-black"
          dangerouslySetInnerHTML={{
            __html: videoTipsDetails?.supportInformation?.title?.[i18n.language]
          }}
        />
        <div
          className="text-lg text-grey-200 mt-2"
          dangerouslySetInnerHTML={{
            __html: videoTipsDetails?.supportInformation?.description?.[i18n.language]
          }}
        />

        <div className="mt-12 text-left">
          <p
            className="text-xl font-bold text-black mb-2"
            dangerouslySetInnerHTML={{
              __html: videoTipsDetails?.contact?.title?.[i18n.language]
            }}
          />
          {videoTipsDetails?.contact?.name && (
            <p className="text-lg text-grey-200 text-left underline flex items-center gap-2">
              <RxAvatar size={24} />
              {videoTipsDetails?.contact?.name}
            </p>
          )}
          {videoTipsDetails?.contact?.email && (
            <a
              className="text-lg text-grey-200 text-left underline flex items-center gap-2"
              href={`mailto:${videoTipsDetails?.contact?.email}`}>
              <RxEnvelopeOpen size={24} />
              {videoTipsDetails?.contact?.email}
            </a>
          )}
          {videoTipsDetails?.contact?.phone && (
            <a
              className="text-lg text-grey-200 text-left underline flex items-center gap-2"
              href={`tel:${videoTipsDetails?.contact?.phone}`}>
              <PhoneOutgoingIcon size={24} />
              {videoTipsDetails?.contact?.phone}
            </a>
          )}
          {videoTipsDetails?.contact?.whatsapp && (
            <a
              className="text-lg text-grey-200 text-left underline flex items-center gap-2"
              href={`https://wa.me/${videoTipsDetails?.contact?.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer">
              <FaWhatsapp size={24} />
              {videoTipsDetails?.contact?.whatsapp}
            </a>
          )}
        </div>
      </div>
    </Popups.FullPagePopup>
  );
}
